import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Logomark from '../layout/logomark.component'

const StyledTitle = styled.div`
	cursor: default;
	display: flex;
	flex-direction: column;

	.title {
		margin-bottom: 0;
	}
`

/**
 * The title component
 * @hideLogo {bool} Defines if should be hide the logo above the title
 * @children {object} The children object
 */
const Title = ({ hideLogo, children }) => (
	<StyledTitle>
		<h1 className="title blue">{children}</h1>
		{hideLogo ? null : <Logomark />}
	</StyledTitle>
)

Title.propTypes = {
	hideLogo: PropTypes.bool
}

export default Title
